import { createSvgIcon } from '@mui/material/utils';

const Shape = createSvgIcon(
  <svg viewBox="0 0 61 61" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M46.1634 56.3406C25.3115 68.1109 8.81562 51.4363 3.17417 41.6277C-5.82358 25.2252 6.59691 15.4911 12.1719 13.469C19.7412 10.7235 26.0256 6.57009 36.88 1.5015C49.1627 -4.234 56.5894 13.8913 58.3747 17.552C60.1599 21.2126 67.3724 44.3687 46.1634 56.3406Z" fill="currentColor" />
  </svg>,

  'Shape',
);

export default Shape;
